import {throttle} from 'lodash-es';

const _collaborationProcess = document.getElementById('collaboration-process');
const windowHeight = window.innerHeight;

function check() {
  if (_collaborationProcess.getBoundingClientRect().y < windowHeight) {
    _collaborationProcess.classList.add('is-in-viewport');
    window.removeEventListener('scroll', throttledCheck);
  }
}

const throttledCheck = throttle(check, 50);

if (_collaborationProcess) {
  window.addEventListener('scroll', throttledCheck);
}
